import React, { useState } from 'react'

const UTILSENDPOINT = process.env.REACT_APP_UTILS_ENDPOINT || 'https://utilities.staging.pollination.cloud'

export const useVsftoVTK = () => {
  const [loading, setLoading] = useState(false)

  const [vtk, setVTK] = useState<Blob | undefined>()

  const fetchVTK = (vsf: Blob) => {
    if (!vsf || vsf.size < 1) return undefined

    setLoading(true)

    return vsf.text().then((fileString) => {
      fetch(`${UTILSENDPOINT}/vsf-to-vtk`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: '*/*',
        },
        body: `{
          "output_format": "vtkjs",
          "vsf": ${fileString}
        }`,
      })
        .catch((e) => {
          throw new Error(e)
        })
        .then(async (res) => {
          if (res.ok) {
            const translatedFile = await res.blob()
            setVTK(translatedFile)
            return translatedFile
          }
          throw new Error('Failed to retrieve .vtkjs from .vsf file.Error translating vsf to vtkjs')
        })
        .finally(() => {
          setLoading(false)
        })
    })
  }

  return {
    loading,
    vtk,
    fetchVTK,
  }
}
